var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selection-switch-container"},_vm._l((_vm.switches),function(item,index){return _c('div',{key:index,staticClass:"switch-button",class:{'active': _vm.isActive(item)},on:{"click":function($event){return _vm.selectItem(item)}}},[_vm._v(" "+_vm._s(_vm._f("allCaps")(_vm._f("translate")(item)))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }